import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    topPurchasedByTags: [],
    topPurchasedProducts: [],
    topGrosingProducts: [],
};

const getters = {
    chartTagsSeriesData: state => {
        const data = state.topPurchasedByTags;

        if (!_.isEmpty(data)) {
            return data.map(tag => ({ value: tag.total, name: tag.name }));
        }

        // return empty series if no date
        return [
            {
                value: 0,
                name: '',
                itemStyle: {
                    normal: {
                        color: '#eee',
                    },
                },
            },
        ];
    },

    chartTopProducts: state => {
        const data = state.topPurchasedProducts;
        const yAxisData = data.map(p => p.name);
        let seriesData = [0];

        if (!_.isEmpty(data)) {
            seriesData = data.map(p => p.total);
        }

        return {
            seriesData,
            yAxisData,
        };
    },

    chartGrossingProducts: state => {
        const data = state.topGrosingProducts;
        const yAxisData = data.map(p => p.name);
        let seriesData = [0];

        if (!_.isEmpty(data)) {
            seriesData = data.map(p => p.total);
        }

        return {
            seriesData,
            yAxisData,
        };
    },
};

const mutations = {
    [type.SET_TOP_PURCHASE_BY_TAGS](state, topPurchasedByTags) {
        state.topPurchasedByTags = topPurchasedByTags;
    },

    [type.SET_TOP_PURCHASE_PRODUCTS](state, topPurchasedProducts) {
        state.topPurchasedProducts = topPurchasedProducts;
    },

    [type.SET_TOP_GROSING_PRODUCTS](state, topGrosingProducts) {
        state.topGrosingProducts = topGrosingProducts;
    },
};

const actions = {
    getChartData({ commit, dispatch, rootState }) {
        const outlet_id = rootState.report.activeOutlet;
        startLoading(dispatch, 'fetch-chart-data');

        let options = {
            since: rootState.report.startDate.format(),
            until: rootState.report.endDate.format(),
            filters: rootState.tillFilter.filters,
        };

        let api = Laroute.route(
            'franchise.report.non_fuel.item.getChartSummary',
            {
                id: outlet_id,
            },
        );

        axios
            .post(api, options)
            .then(res => {
                endLoading(dispatch, 'fetch-chart-data');

                commit(type.SET_TOP_PURCHASE_BY_TAGS, res.data.tags);
                commit(type.SET_TOP_PURCHASE_PRODUCTS, res.data.top_purchased);
                commit(type.SET_TOP_GROSING_PRODUCTS, res.data.top_revenue);

                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-chart-data');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/report-product.js